<template>
  <div>
    <imgHeader imgUrl="/img/12加入我们-banner.jpg" />
    <div class="w main">
      <h3 class="title" style="text-align:center;" data-aos="zoom-in">
        {{ $t('joinUs.staffStyleTitle') }}
      </h3>
      <div class="line line1"></div>
      <p class="desc" data-aos="zoom-in">
        {{ $t('joinUs.staffStyleDesc') }}
      </p>
      <div class="container flex">
        <img
            :src="item.imgUrl"
            alt=""
            v-for="(item, index) in imgList"
            :key="index"
            data-aos="zoom-in"
            :data-aos-delay="index * 500"
        />
      </div>
      <h3 class="title" style="text-align:center;" data-aos="zoom-in">
        {{ $t('joinUs.joinUsTitle') }}
      </h3>
      <div class="line line1"></div>
      <p class="desc" data-aos="zoom-in">
        {{ $t('joinUs.joinUsDesc') }}
      </p>
      <div class="container flex" data-aos="zoom-in">
        <div class="item" @mouseenter="handEnter(1, false)">
          <img
              src="/img/12加入我们-icon1-hover.png"
              alt=""
              v-if="currentIndex === 1 && !isHover"
          />
          <img src="/img/12加入我们-icon1-normal.png" alt="" v-else />
          <h3>{{ $t('joinUs.salaryTitle') }}</h3>
          <div class="desc">{{ $t('joinUs.salaryDesc') }}</div>
        </div>
        <div class="item" @mouseenter="handEnter(2, true)">
          <img
              src="/img/12加入我们-icon2-hover.png"
              alt=""
              v-if="currentIndex === 2 && isHover"
          />
          <img src="/img/12加入我们-icon2-normal.png" alt="" v-else />
          <h3>{{ $t('joinUs.abroadTitle') }}</h3>
          <div class="desc">{{ $t('joinUs.abroadDesc') }}</div>
        </div>
        <div class="item" @mouseenter="handEnter(3, true)">
          <img
              src="/img/12加入我们-icon3-hover.png"
              alt=""
              v-if="currentIndex === 3 && isHover"
          />
          <img src="/img/12加入我们-icon3-normal.png" alt="" v-else />
          <h3>{{ $t('joinUs.talentTitle') }}</h3>
          <div class="desc">{{ $t('joinUs.talentDesc') }}</div>
        </div>
      </div>
    </div>
    <div class="position">
      <div class="w flex job">
        <div>
          <div class="hLine" data-aos="fade-up" data-aos-offset="400"></div>
        </div>
        <div class="announcing" data-aos="fade-up" data-aos-offset="400">
          {{ $t('joinUs.positionAnnouncing') }}
        </div>
        <div class="job-list">
          <div
              class="job-list-item flex"
              v-for="(item, index) in list"
              :key="item.type"
              data-aos="fade-up"
              :data-aos-delay="index * 120"
              data-aos-offset="600"
          >
            <div class="job-list-title">
              <h3 class="job-name">{{ item.positionName }}</h3>
              <div class="job-address">
                <h4>
                  <span>{{ $t('joinUs.location') }}：</span>
                  {{ item.address }}
                </h4>
              </div>
              <div class="job-time">{{ $t('joinUs.publishTime') }}：{{ item.time }}</div>
            </div>
            <div class="job-list-responsibility">
              <div>{{ $t('joinUs.responsibility') }}：</div>
              <p
                  v-for="(resp, idx) in item.responsibility"
                  :key="idx"
              >
                {{ idx + 1 }}、{{ resp }}
              </p>
            </div>
            <div
                class="job-list-application flex"
                @click="toPosition(item.type)"
            >
              <div class="flex application">{{ $t('joinUs.applyNow') }}</div>
              <span>></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialog_position :dialogVisible.sync="dialogVisible" :type="type" />
  </div>
</template>

<script>
import dialog_position from '../components/dialog_position.vue'
import { t } from '@/VueI18n'

export default {
  name: 'JoinUs',
  components: { dialog_position },
  data() {
    return {
      imgList: [
        { imgUrl: require('/public/img/12加入我们-img1.jpg') },
        { imgUrl: require('/public/img/12加入我们-img2.jpg') },
        { imgUrl: require('/public/img/12加入我们-img3.jpg') },
        { imgUrl: require('/public/img/12加入我们-img4.jpg') },
        { imgUrl: require('/public/img/12加入我们-img5.jpg') },
      ],
      currentIndex: 1,
      isHover: false,
      dialogVisible: false,
      type: '',
      list: [
        {
          positionName: t('joinUs.purchaseName'),
          address: t('joinUs.yiwu'),
          time: '2021-10-10',
          type: 'purchase',
          responsibility: [
            t('joinUs.purchaseResp1'),
            t('joinUs.purchaseResp2'),
            t('joinUs.purchaseResp3'),
            t('joinUs.purchaseResp4'),
            t('joinUs.purchaseResp5'),
          ],
        },
        {
          positionName: t('joinUs.salesName'),
          address: t('joinUs.yiwu'),
          time: '2021-10-10',
          type: 'sales',
          responsibility: [
            t('joinUs.salesResp1'),
            t('joinUs.salesResp2'),
            t('joinUs.salesResp3'),
            t('joinUs.salesResp4'),
            t('joinUs.salesResp5'),
          ],
        },
      ],
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateList()
    }
  },
  mounted() {
    this.updateList()
  },
  methods: {
    handEnter(index, state) {
      this.currentIndex = index
      this.isHover = state
    },
    toPosition(type) {
      this.type = type
      this.dialogVisible = true
    },
    updateList() {
      this.list = [
        {
          positionName: t('joinUs.purchaseName'),
          address: t('joinUs.yiwu'),
          time: '2021-10-10',
          type: 'purchase',
          responsibility: [
            t('joinUs.purchaseResp1'),
            t('joinUs.purchaseResp2'),
            t('joinUs.purchaseResp3'),
            t('joinUs.purchaseResp4'),
            t('joinUs.purchaseResp5'),
          ],
        },
        {
          positionName: t('joinUs.salesName'),
          address: t('joinUs.yiwu'),
          time: '2021-10-10',
          type: 'sales',
          responsibility: [
            t('joinUs.salesResp1'),
            t('joinUs.salesResp2'),
            t('joinUs.salesResp3'),
            t('joinUs.salesResp4'),
            t('joinUs.salesResp5'),
          ],
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 60px;
}
.desc {
  text-align: center;
  color: #666;
}
.container {
  margin-top: 60px;
  justify-content: space-between;
}
.item {
  text-align: center;
  cursor: pointer;
  img {
    border-radius: 50%;
    box-shadow: 0 0 10px #eaeaea;
  }
}
.position {
  display: flex;
  align-items: center;
  height: 721px;
  margin-bottom: 90px;
  background: url('/img/12加入我们-img6.jpg') no-repeat 50%;
  background-size: cover;
}
.hLine {
  width: 2px;
  height: 60px;
  background-color: #fff;
}
.announcing {
  padding: 0 10px;
  width: 50px;
  font-size: 30px;
  color: #fff;
  writing-mode: vertical-rl;  /* 垂直方向，从右向左换行 */
  text-orientation: mixed;
}
.job-list {
  margin-left: 60px;
}
.job-list-item {
  margin-bottom: 30px;
  border-radius: 10px;
  background-color: #fff;
  overflow: hidden;
}
.job-list-responsibility {
  width: 900px;
  padding: 25px 50px;
  p {
    margin: 0;
    line-height: 1.8;
    color: #333;
    font-size: 16px;
  }
}
.job-list-title {
  padding: 20px 50px;
  background-color: var(--bg-color);
}
.job-address {
  h4 {
    margin-bottom: 35px;
    span {
      font-weight: normal;
    }
  }
}
.job-time {
  width: 150px;
  font-size: 14px;
  color: #333;
}
.job-list-application {
  padding: 10px 30px;
  align-items: center;
  color: #fff;
  background-color: #409eff;
  cursor: pointer;
}
.application {
  width: 30px;
  flex-direction: column;
  writing-mode: vertical-rl;  /* 垂直方向，从右向左换行 */
  text-orientation: mixed;
}
</style>